import { Injectable } from '@angular/core';
import {Company} from "./include/structures";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { Globals } from './globals';
import { SelectconfigfileComponent } from './common/selectconfigfile/selectconfigfile.component';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable()
export class Config{

    //variabili generali
    id="";
    softwarename="";
    softwareversion="";
    softwareicon="";
    softwarebackground="";
    softwarecolor="";
    license="";
    company:Company=new Company();
    favIcon: HTMLLinkElement = document.querySelector('#appIcon');
    serverUrl="";
    copyright=true;
    expired_license="";
    config:any; //file di configurazione
    changeLog:any; //contenuto file con il changeLog


     constructor(
        private http:HttpClient,
        private titleService: Title
  
      ){}

    setConfig(config,setTitle){
            this.config=config;
            
            if(Array.isArray(this.config['serverUrl'])){
              this.config['serverUrl']=this.config['serverUrl'][0];
            }
            this.serverUrl=this.config['serverUrl'];
            Globals.ws.base=this.config['serverUrl']+"/api.php";
            Globals.ws.basev2=this.config['serverUrl']+"/apiv2.php";
            this.softwareversion=this.config['version'];
            this.softwarename=this.config['name'];
            this.softwarebackground=this.config['background'];
            this.softwarecolor=this.config['color'];
            this.license=this.config['license'];
            this.softwareicon=this.config['icon'];
            this.company=this.config['company'];
            let allowRole=this.config['allowRole']==undefined?['admin']:this.config['allowRole'];
            this.copyright=this.config['copyright']==undefined?this.config['copyright']:true;
            this.id=this.config['id']==undefined?this.config['name']:this.config['id'];
            Globals.access.allowRole=allowRole;
            
            //if(this.config['favicon'])
              //this.favIcon.href=this.config['favicon'];
            if(setTitle)
              this.titleService.setTitle(this.softwarename);
            
            /*configurazioni*/
            Globals.access.prefix=this.softwarename;
    }

    /**
     * ottiene le configurazioni della piattaforma dal server di manager
     */
    remoteConfig(url_manager="https://c1m.it/server",setTitle,onComplete:Function){
      //richiedi la configurazione al server di C1M
      const headers=new HttpHeaders({"token":"5f2b5cdbe5194f10b3241568fe4e2b24"});
      const endpoint=url_manager+"/apiv2.php/platforms/getPlatform";
        const platformname=window.location.host;
        this.http.post(endpoint,{name:platformname},{headers:headers}).subscribe((remoteConfig:any)=>{
        
        if("url_server" in remoteConfig){
            const config={
              serverUrl:remoteConfig.url_server,
              allowRole:["superuser","admin","manager"],
              icon:remoteConfig.icon,
              favicon:remoteConfig.favicon,
              background:remoteConfig.background,
              copyright:remoteConfig.copyright,
              name:remoteConfig.title,
              company:remoteConfig.company
            }

            this.setConfig(config,setTitle);
            if(onComplete)
              onComplete(true);
          }else{
            if(onComplete)
              onComplete(false);
          }
        });
    }

     
    loadConfig(onComplete:Function,setTitle=true){
        this.http.get(Globals.rootpath+"config.json").pipe(
          catchError(
            (error:HttpErrorResponse)=>{

              if(error.status==404){ //file non presente
                this.remoteConfig("https://c1m.it/server",setTitle,onComplete);
              }


              return throwError(() => null);
            }
        )
    ).subscribe((value:any)=>
      {
        if("url_manager" in value){
          this.remoteConfig(value.url_manager,setTitle,onComplete);
        }else{
          
          if(Array.isArray(value)){
            Globals.modal.showModal(SelectconfigfileComponent,[
              {"name":"configs","value":value}
            ],(instance)=>{
              let config=instance['selected'];
              this.setConfig(config,setTitle);
              if(onComplete)
                onComplete(true);
            });
          }else{
            this.setConfig(value,setTitle);
            if(onComplete)
              onComplete(true);
          }
        }
      });
      
    }

    loadChangeLog(onComplete:Function){
        this.http.get(Globals.rootpath+"changelog.json").subscribe((value)=>{
          
          if(value){
            this.changeLog=value;
          }

          if(onComplete)
            onComplete();
      });
    }
}